import constants from '../utils/constants';

export default {
  api_url: constants.API.ENDPOINT,
  export_url: constants.API.EXPORT_ENDPOINT,
  ai_url: constants.API.AI_ENDPOINT,
};
